<template>
    <modal
        name="productos-a-reactivar"
        transition="pop-out"
        :width="800"
        height="auto"
        scrollable
        id="productos-a-reactivar"
        :adaptive="true"
    >
        <div class="card m-0">
            <div class="card-header">
                <div class="row">
                    <div class="col-10">
                        <h2>Listado de productos a reactivar</h2>
                    </div>
                    <div class="col-2">
                        <button type="button" class="close" @click.prevent="close()">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                </div>
            </div>
            <ContentOrLoading>
                <template v-if="!loading">
                    <ProductosComponent
                        v-if="productos.length"
                        :productos="productos"
                        :qr_code="qr_code"
                        @confirm="reactivarProductos"
                        @close="close"
                    />
                    <div class="alert alert-info m-4" v-else>
                        <b>No hay productos a reactivar</b>
                    </div>
                </template>
            </ContentOrLoading>
        </div>
    </modal>
</template>

<script>
    import ProductosComponent from "../ProductosComponent.vue";

    export default {
        props: ["productos", "qr_code"],
        data() {
            return {
                loading: false
            };
        },
        methods: {
            reactivarProductos(productosSeleccionados) {
                this.$emit("reactivarProductos", productosSeleccionados, "productos-a-reactivar");
            },
            close() {
                this.$emit("close", "productos-a-reactivar");
            }
        },
        components: {
            ProductosComponent
        }
    };
</script>
